module.exports = __webpack_public_path__ + "static/media/eddy-travia-200x200.fbacf349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/eddy-travia-200x200.jpg
// module id = 1784
// module chunks = 147